module.exports = __webpack_public_path__ + "img/maintainability-icon.478c77f5.svg";